import { TOOL_IDS } from '@adsk/alloy-provider';
import { BulldozerIcon } from '@adsk/alloy-react-icon';

import { getEntitiesByIds } from './api';
import {
  PlanTaskEntityBlock,
  PlanTaskPluralText,
  PlanTaskEntityMenuItem,
} from './components';
import PlanTaskEntityActivityCard from './components/PlanTaskEntityActivityCard/PlanTaskEntityActivityCard';
import { planTaskPluginMetadata } from './consts';
import { onAddRelationships, onRemove } from './helpers';
import { PlanTaskReferencePickerPlugin } from './types';

export const planTaskPlugin: PlanTaskReferencePickerPlugin = {
  metadata: planTaskPluginMetadata,
  toolId: TOOL_IDS.SCHEDULE,
  PluralText: PlanTaskPluralText,
  EntityBlock: PlanTaskEntityBlock,
  EntityMenuItem: PlanTaskEntityMenuItem,
  renderIcon: BulldozerIcon.renderIcon,
  ActivityCard: PlanTaskEntityActivityCard,
  getEntitiesByIds,
  onRemove,
  onAddRelationships,
  is3LOSupported: true,
};
